module.exports = __webpack_public_path__ + "img/1-4.0b92fbc8.svg";